import "./Landing.css";
import PBIReport from "../PowerBI/PBIReport";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import * as pbi from "powerbi-client";
import "../PowerBI/powerBi.css";
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { apiHelper } from "../lib/ApiHelper";
import deleteWarningPopUp from '../deleteWarningPopUp';
const pbiUrl = 'https://app.powerbi.com/reportEmbed?';
const pbiConfigUrl = '&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZSwiZGlzYWJsZUFuZ3VsYXJKU0Jvb3RzdHJhcFJlcG9ydEVtYmVkIjp0cnVlfX0%3d';

export default function TitleReport(props) {
    const [dashboardReport, setDashboardReport] = useState(null);
    const reportRef = useRef(null);
   // const [showConfirmation, setShowConfirmation] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isProcessing, setProcessing] = useState(false);
    const [isbnLists, setIsbnLists] = useState(null);
    const [uniqueListCount, setUniqueListCount] = useState(0);
    const models = pbi.models;
    const name = 'Hub Title Report';
   // const reportId = "c19a9aad-e583-4c69-969f-e27b80e8a03b";
    const navigate = useNavigate();
    const pbiConfig = {
        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
        tokenType: models.TokenType.Aad,
        accessToken: props.token,
        embedUrl: `${pbiUrl}reportId=${props.reportId}${pbiConfigUrl}`,

        permissions: models.Permissions.Read.All,
        id: props.reportId,
        settings: {
            layoutType: models.LayoutType.Custom,
            customLayout: {
                displayOption: models.DisplayOption.FitToPage
            },
            panes: {
                filters: {
                    expanded: false,
                    visible: true
                },
                pageNavigation: {
                    visible: false
                },
            },

        }
    };



  

    const handleVisualClicked = async (event) => {
        try {
            if (isProcessing) { setErrorMessage('Already processing a request'); return; }
            const actionButtonTitle = 'Clear All Reprint Data';
            const embedContainer = document.getElementsByClassName("invHubTitleReport")[0];
            const report = await powerbi.get(embedContainer);
            const pages = await report.getPages();
            if (pages?.length == 0) { console.warn(`There are no pages on the report`); return; }
            const visuals = (await pages[0].getVisuals())?.filter(r => r.type.toLowerCase() == 'actionbutton' && r.title.toLowerCase() == actionButtonTitle.toLowerCase()) ?? [];
            if (visuals.length == 0) { console.warn(`There is no button with title ${actionButtonTitle}`); return; }
            if (visuals[0].name.toLowerCase() != event.detail.visual.name.toLowerCase()) { return; }
            const isbnList = await getTitleDashboardISBNList();
            setIsbnLists(isbnList);

            const uniqueArray = [...new Set(isbnList)];
            setUniqueListCount(uniqueArray?.length ?? 0);

        } catch ({ name, message }) {
            console.info(`%cERROR: PBI visual clicked error: ${name} -> ${message}`, 'background: #D2042D; color: #ffffff');
        }
    }
    const setIsbnListsReprints = async () => {
        setProcessing(true);
        //setShowConfirmation(false);
        try {
            setSuccessMessage(false); setErrorMessage(null);
            if (!isbnLists) { setErrorMessage('No ISBNs selected to clear!'); return; }
            const top100IsbnLists = isbnLists.slice(0, 100);
            const res = await apiHelper.inventoryPostCall("deleteMultipleRerpint", top100IsbnLists);
            setSuccessMessage(true);
            alert('All Reprint information has been deleted for selected ISBN(s) and Title has been reset to Open.');
            setIsbnLists(null);
        } catch ({ name, message }) {
            setErrorMessage(message);
        } finally { setProcessing(false); }
    }
 
    const getTitleDashboardISBNList = async (report) => {
        let isbnList = [];
        console.info('Loading...');
        try {
            var embedContainer = document.getElementsByClassName("invHubTitleReport")[0];
            var report = await powerbi.get(embedContainer);
            let pages = await report.getPages();
            if (pages?.length == 0) { return isbnList; }
            const visuals = (await pages[0].getVisuals())?.filter(r => r.type.toLowerCase() == 'tableex' && r.title.toLowerCase() == 'zpoc') ?? [];
            if (visuals?.length == 0) { return ''; }
            const data = (await visuals[0].exportData(models.ExportDataType.Summarized))?.data ?? null;
            if (!data) { return isbnList; }
            const lines = data.split("\r\n");
            const headers = lines[0].split(",");
            const isbnIndex = headers.findIndex(item => item.toLowerCase().trim() == 'isbn') ?? 0;
            for (var i = 1; i < lines.length; i++) {
                const currentline = lines[i].split(",");
                const isbn = currentline[isbnIndex]?.trim() ?? '';
                if (isbn?.length > 0) {
                    isbnList.push(isbn);
                }
            }
        } catch ({ name, message }) {
            console.warn('Failed to get isbnlist from pbi report with error', name, message);
        }
        finally {
            console.info('completed.');
        }
        return isbnList;
    }


    return (
        <>
            {props.token == '' || props.reportId === '' ? <>Loading...</> : <>
                <PowerBIEmbed
                    embedConfig={pbiConfig}
                    eventHandlers={
                        new Map([
                            ['visualClicked', (event) => handleVisualClicked(event)],

                        ])}
                    cssClassName={"Embed-container dboard invHubTitleReport"}
                />

                {isbnLists?.length > 0 &&

                    (
                        <div className="delete-warning-rpt">
                            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog modal-xl" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Delete Reprints</h5>
                                            <button type="button" className="close" onClick={() => (setIsbnLists(null))} aria-label="Close" >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">

                                        {uniqueListCount <= 100 ? <p>{uniqueListCount} {uniqueListCount == 1 ? "title" : "titles"} will have reprint data permanently deleted and status updated to Open</p> : <p>The first 100 titles will have reprint data permanently deleted and status updated to Open. Please repeat for additional titles.</p>}
                                        <h5 className="delete-warning">Are you sure ?</h5>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" id="b1" className="btn btn-secondary mr-2" onClick={setIsbnListsReprints} >Yes</button>
                                        <button type="button" id="b2" className="btn btn-secondary ml-2" onClick={() => (setIsbnLists(null))} >No</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-backdrop fade show"></div>
                        </div>
                    )

                }
            </>}

            {/*showConfirmation &&
                <deleteWarningPopUp
                    show={showConfirmation}
                    title='Clear Reprint Confirmation'
                    text='Are you sure?'
                    onClose={() => setShowConfirmation(false)}
                    onDelete={() => setIsbnListsReprints()} />*/
            }            
        </>
    )
}


